// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__HvPSn","addWidgetButton":"Header_addWidgetButton__s0MHw","dashboardTabs":"Header_dashboardTabs__35yO6","active":"Header_active__3wfbs"};